import React, { Component } from "react";
import { Form } from "react-form";
import { Scrollbars } from "react-custom-scrollbars";
import { connect } from "react-redux";
import { map } from "lodash";
import {
  getOrdersPerZone,
  getRejectedOrdersPerZone,
  getSearchOrdersPerZone
} from "./../../store/actions/orderReports";
import ReactPaginate from "react-paginate";
import SelectMenu from "../UI/Select";
import TextFields from "../UI/TextFiled";
import Dialog from "../UI/Dialog";
import { Initiator } from "../../utils/constants";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      isRejectedOrdersDialogOpen: false,
      ordersLength: 0,
      searchValue: "",
      zoneId: null,
      rejectedId: [],
      choosenValue: "",
      filterValue: "All",
      rejectedIdLength: 0,
      id: ""
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleRejectedClick = this.handleRejectedClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  async componentDidMount() {
    await this.props.getOrdersPerZone(this.props.auth.token, 1);
    let ordersReportShow = [];
    map(this.props.ordersReport.results, data => ordersReportShow.push(data));
    if (this.state.ordersLength <= ordersReportShow.length) {
      this.setState({ ordersLength: ordersReportShow.length });
    }
  }
  onMouseWheel(e) {
    const currentScrollDelta = this.refs.scrollbars.getScrollLeft();
    this.refs.scrollbars.scrollLeft(currentScrollDelta + e.deltaY);
  }
  async handleClick(pagenumber) {
    await this.setState({ currentPage: pagenumber.selected + 1 });
    this.props.getOrdersPerZone(this.props.auth.token, this.state.currentPage);
  }
  closeRejectedOrdersDialog = () => {
    this.setState({ isRejectedOrdersDialogOpen: false });
  };
  async handleRejectedClick(pagenumber) {
    await this.props.getRejectedOrdersPerZone(
      this.props.auth.token,
      this.state.id,
      pagenumber.selected + 1
    );
    this.setState({
      rejectedId: this.props.ordersReport.rejectedId.results
    });
  }
  closeRejectedOrdersDialog = () => {
    this.setState({ isRejectedOrdersDialogOpen: false });
  };
  async openRejectedOrdersDialog(id) {
    await this.setState({ id });
    await this.props.getRejectedOrdersPerZone(this.props.auth.token, id, 1);
    await this.setState({
      isRejectedOrdersDialogOpen: true,
      rejectedId: this.props.ordersReport.rejectedId.results
    });
    if (this.state.rejectedIdLength <= this.state.rejectedId.length) {
      await this.setState({
        rejectedIdLength: this.state.rejectedId.length
      });
    }
  }
  handleInput(e) {
    this.setState({ searchValue: e.target.value });
  }
  onSearch() {
    this.props.getSearchOrdersPerZone(
      this.props.auth.token,
      this.state.searchValue,
      this.state.choosenValue
    );
  }

  async onFilter(e) {
    let choosenValue = "";
    let filterValue = "";

    if (e.values.OrderInitiator === "Non Foodna App") {
      choosenValue = "tam";
      filterValue = "Non Foodna App";
    } else if (e.values.OrderInitiator === "Foodna App") {
      choosenValue = "foodna";
      filterValue = "Foodna App";
    } else {
      filterValue = "All";
    }
    await this.setState({ choosenValue, filterValue });
    this.props.getSearchOrdersPerZone(
      this.props.auth.token,
      this.state.searchValue,
      this.state.choosenValue
    );
  }
  render() {
    const ordersReport = map(this.props.ordersReport.results, data => data);
    let currentOrdersCount =
      this.state.ordersLength > 0
        ? this.state.ordersLength
        : ordersReport.length;
    let pageCount = Math.ceil(
      this.props.ordersReport.count / currentOrdersCount
    );
    const rejectedOrders = { ...this.props.ordersReport.rejectedId };
    let currentRejectedIDCount =
      this.state.rejectedIdLength > 0
        ? this.state.rejectedIdLength
        : this.state.rejectedId.length;
    let pageCountRejectedId = Math.ceil(
      rejectedOrders.count / currentRejectedIDCount
    );

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Monitoring Dashboard</h1>
              </div>
              <div className="col-xs-3">
                <Form>
                  {formApi => (
                    <form
                      onSubmit={formApi.submitForm}
                      className="search"
                      onChange={this.handleInput}
                    >
                      <TextFields type="text" hintText="Search" />
                      <button
                        className="no-style search-btn pointer"
                        onClick={this.onSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <Form onSubmit={this.submitted} onChange={this.onFilter}>
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="row">
                  <div className="col-xs-3 mb-15">
                    <SelectMenu
                      field="OrderInitiator"
                      label="Order Initiator"
                      menu={Initiator}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>
          <Scrollbars
            ref="scrollbars"
            onWheel={this.onMouseWheel.bind(this)}
            className="table monitorDashboard"
            style={{ maxWidth: "100%" }}
            autoHeight
            autoHeightMax={"100%"}
          >
            <table style={{ width: "1600px" }}>
              <thead>
                <tr>
                  <th>Order Initiator</th>
                  <th>Zone</th>
                  <th>Total Numbers of Orders</th>
                  <th>Total Number of Rejected Orders</th>
                  <th>Total Number of Completed Orders</th>
                  <th>Total Number of Delayed Orders</th>
                  <th>Total Number of Drivers</th>
                  <th>Average Delivery Time</th>
                  <th>Average Meal Preparation Time</th>
                </tr>
              </thead>
              <tbody>
                {map(this.props.ordersReport.results, (row, i) => (
                  <tr key={i}>
                    <td>{this.state.filterValue}</td>
                    <td>{row.zone}</td>
                    <td>{row.total_numbers_of_orders}</td>
                    <td
                      className="pointer"
                      onClick={() => this.openRejectedOrdersDialog(row.id)}
                    >
                      {row.total_numbers_of_rejected_orders}
                    </td>
                    <td>{row.total_numbers_of_completed_orders}</td>
                    <td>{row.total_numbers_of_delayed_orders}</td>
                    <td>{row.total_numbers_of_drivers || 0}</td>
                    <td>{row.average_delivery_time || 0} min.</td>
                    <td>{row.average_meal_preparation_time || 0} min.</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Scrollbars>
          {pageCount > 1 && (
            <ReactPaginate
              onPageChange={this.handleClick}
              pageCount={pageCount}
              initialPage={0}
              breakClassName={"break-me"}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
            />
          )}
        </div>
        <Dialog
          open={this.state.isRejectedOrdersDialogOpen}
          handleClose={this.closeRejectedOrdersDialog}
        >
          <div className="popup-title text-center">
            <h2>Total Number of Rejected Orders</h2>
          </div>
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                </tr>
              </thead>
              <tbody>
                {map(this.state.rejectedId, (row, i) => {
                  return (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {pageCountRejectedId > 1 && (
              <ReactPaginate
                onPageChange={this.handleRejectedClick}
                pageCount={pageCountRejectedId}
                initialPage={0}
                breakClassName={"break-me"}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                previousLabel={<i className="fa fa-chevron-left" />}
                nextLabel={<i className="fa fa-chevron-right" />}
              />
            )}
          </div>
          <button
            className="no-style close-btn"
            onClick={this.closeRejectedOrdersDialog}
          >
            ×
          </button>
        </Dialog>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    ordersReport: state.ordersReport,
    auth: state.auth
  };
}

export default connect(
  mapStateToProps,
  {
    getOrdersPerZone,
    getRejectedOrdersPerZone,
    getSearchOrdersPerZone
  }
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Operation-room/Dashboard.js